import axios from "axios";
import { calculateTimeByHours } from "../Utils/utils/CommanFnc";

// const register = (username, email, password) => {
//   return axios.post(API_URL + "signup", {
//     username,
//     email,
//     password,
//   });
// };

const login = (formData) => {

  const response  = axios({
    url:"/login",
    data:formData,
    method:"POST",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response) => {
    const data = response.data
    if (data.token)  {
      let authData = {
        token:data.token,
        user:data.user
      }
      const expDT = calculateTimeByHours();
      localStorage.setItem("expDT", expDT);
      localStorage.setItem("user", JSON.stringify(authData));
    }
    return data;
  })
  return response
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("expDT")
  localStorage.removeItem("SelectedBusiness")
  return true
};

const authService = {
  login,
  logout,
};

export default authService;